module.exports = __webpack_public_path__ + "static/media/zalo_oa.75ac03d7.png";